import DataTable from "react-data-table-component";

/**
 * Wrapper sin fixedHeader (evita removeChild con React 18/19).
 * El scroll se maneja con CSS en el contenedor padre.
 */
const AppDataTable = ({ scrollHeight = "400px", tableWrapperClassName = "", ...props }) => {
  return (
    <div
      className={`w-full overflow-x-auto overflow-y-auto border rounded-lg ${tableWrapperClassName}`}
      style={{ maxHeight: scrollHeight }}
    >
      <DataTable
        responsive
        highlightOnHover
        pagination
        paginationPerPage={10}
        paginationRowsPerPageOptions={[10, 25, 50, 100]}
        {...props}
      />
    </div>
  );
};

export default AppDataTable;
